import script from "./MaterialCaroussel.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialCaroussel.vue?vue&type=script&setup=true&lang=js"

import "./MaterialCaroussel.vue?vue&type=style&index=0&id=58f647a9&lang=css"

const __exports__ = script;

export default __exports__